export function createSearchableString(values: string[]): string {
  return values.map((value) => normalizeForSearch(`${value}`)).join(' ');
}

export function normalizeForSearch(value: string): string {
  return `${value}`
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u0142/g, 'l')
    .toLowerCase();
}

/** Filter items by name using the same normalization as documentation/directory search. */
export function filterItemsByName<T extends { name: string }>(
  items: T[],
  searchPhrase: string
): T[] {
  const normalized = searchPhrase.trim();
  if (!normalized) return items;
  const key = normalizeForSearch(normalized);
  return items.filter((item) =>
    normalizeForSearch(item.name).includes(key)
  );
}

export function genericSearchPhraseValidation(phrase: string): boolean {
  return phrase.length > 2;
}
